import { List } from 'components/List';
import { CREATE_ROUTE } from 'services/constants';
import { useGet } from 'services/Http';

const columns = ['Name', 'ICD-10 Codes'];
const columnWidths = [200, 800];

export const DiagnosesList = () => {
    const diagnoses = useGet('/reference/diagnoses/');

    return (
        <List
            pageTitle="Diagnoses"
            columnNames={columns}
            columnWidths={columnWidths}
            isLoading={!diagnoses}
            listData={diagnoses?.map((d) => [d.oid, d.codes.map((c) => c.code).join(', ')])}
            createPath={`/diagnoses/${CREATE_ROUTE}`}
            editPath="/diagnoses"
            createButtonLabel="Create Diagnosis"
        />
    );
};
